import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import { project1, project2, project3 } from '../../../assets';
import axios from 'axios';
import { useParams } from 'react-router-dom';


const Others = () => {

      const { t, i18n } = useTranslation();
                         const currentLanguage = i18n.language; // Aktif dili alıyoruz
                         const { id } = useParams(); // URL'deki id parametresi



                         const [blogs, setBlogs] = useState([]);
                                 const [isLoading, setIsLoading] = useState(true);
                               
                                 useEffect(() => {
                                   getProducts();
                                 }, []);
                               
                                 const getProducts = async () => {
                                   try {
                                     const response = await axios.get(
                                       `https://www.gpr.az/gpr/news.php`,
                                       { withCredentials: false }
                                     );
                                       
                                       const filteredBlogs = response.data.data.filter((blog) => blog.id !== id);
                                       setBlogs(filteredBlogs.reverse());
                                     console.log(response.data.data)
                                     setIsLoading(false);
                                   } catch (error) {
                                     console.error("Error fetching products:", error);
                                   }
                                 };

                                  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  }; 


  return (
    <>
        <div className='bg-[#1C1C1C] py-[10px] mt-[40px] md:mt-[80px]'>
        <div className="max-w-container mx-auto mb-[100px]">
        <div className="flex justify-center items-center mx-auto mt-[60px]">
        </div>

        <p className="text-[28px] md:text-[40px] font-bold text-center text-gradient md:mb-10 mb-4">
          {t("Digər xəbərlər")}
        </p>
        <div className="relative">
          <Swiper
            effect={'coverflow'} 
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={3} 
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
            }}
            breakpoints={{
              0: { slidesPerView: 1 }, // Mobil ekranlar (640px altı)
              640: { slidesPerView: 2 }, // Tablet boyutları
              1024: { slidesPerView: 3 }, // Büyük ekranlar
            }}
            pagination={{ el: '.swiper-pagination', clickable: true }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              clickable: true,
            }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="swiper_container" 
          > 
            {blogs.map((project) => (  
              <SwiperSlide key={project.id}>
                <a key={project.id} href={`/${currentLanguage}/news/${project.id}`} className="relative group">
               <div className="relative md:w-[400px]">
                 <img
                   className="rounded-[20px] object-cover md:w-[397px] md:h-[365px] mb-4 drop-shadow-[0px_10px_20px_rgba(0,0,0,0.3)]"
                   src={`https://www.gpr.az/gpr/${getLocalizedField(project, "image1")}`}
                   alt={`Project ${project.id}`}
                 />
                 <div className="absolute inset-0 bg-[#91303F] opacity-0 group-hover:opacity-40 transition-opacity duration-300 rounded-[20px]"></div>
                 
                 {/* Başlık İçin Yeni Efekt */}
                 <div className="absolute bottom-0 left-0 w-full p-4 rounded-b-[20px] bg-gradient-to-t from-black/80 to-transparent">
                   <p className="text-white text-lg font-bold drop-shadow-[0px_3px_5px_rgba(0,0,0,0.8)]">
                     {getLocalizedField(project, "title")}
                   </p>
                 </div>
               </div>
             </a>
              </SwiperSlide>
            ))} 
          </Swiper> 
          {/* Navigation buttons */} 
          <div className="swiper-button-prev absolute top-1/2 left-0 z-10 -translate-y-1/2 cursor-pointer text-gradient">
       
          </div>
          <div className="swiper-button-next absolute top-1/2 right-0 z-10 -translate-y-1/2 cursor-pointer text-gradient">
         
          </div>
        </div>
      </div>
        </div>
    </>
  )
}

export default Others